module.exports = __webpack_public_path__ + "static/img/好物入驻.b947cb4f.png";